const GET_LABEL_INTERVAL = 500; // interval for getting page title from toolbar (ms)
const GET_LABEL_TIMEOUT = 5000; // timeout for getting page title from toolbar (ms)
const MAX_RECENTLY_VISITED = 20; // max items in "recently visited"

const waitForElement = (mostRecentlyVisited) =>
  new Promise(resolve => {
    var interval;
    const wait = () => {
      let toolbarEl = document.querySelector(".v-toolbar__title");
      if (!toolbarEl) {
        toolbarEl = document.querySelector("#monolith #plugin")
      }
      if (toolbarEl){
        let label = toolbarEl.textContent;

        // If the label retrieved is the same as the curent recently visited, then the new
        //  content has not finshed loading, and we need to continue waiting for the new page label
        // Also always update if there is no recent history
        // Note: this relies on the vue router preventing redundant navigation
        if (label && label !== '' && !label.includes(' - undefined')){ // the angular pages sometimes load with a toolbar with an empty label that takes a bit to fill in (also applied when toolbar text has "- undefined" in it)

          // remove asterisk symbol from the end if exists
          if (label.endsWith('*')) {
            label = label.slice(0, -1);
          }

          if (!mostRecentlyVisited || (label != mostRecentlyVisited.label)){
            if (interval) clearTimeout(interval);
            resolve(label);
            return;
          }
        }
      }
      interval = setTimeout(wait, GET_LABEL_INTERVAL);
    }
    wait();
    setTimeout(function(){ if (interval) clearTimeout(interval);}, GET_LABEL_TIMEOUT);
  });


export default new class bookmarks {
  constructor() {

    this.mapIcons = (listType, currentList) => {
      if (!listType) listType = "bookmarks";

      const storedBookmarks = localStorage.getItem(listType) ? JSON.parse(localStorage.getItem(listType)) : [];
      let bookmarks = storedBookmarks.map((b) => {
        let iconKey = Object.keys(this.iconMap).find((l) =>{
          return b.label.includes(l);
        });
        b.icon = this.iconMap[iconKey] || "mdi-bookmark";
        return b;
      })
      return bookmarks;
    }

    this.iconMap = {
      "Request " : "mdi-file",
      "Start Request" : "mdi-file-plus",
      "My Requests": "mdi-file-multiple",
      "Monitor Requests": "mdi-file-find",
      "Manage Requests": "mdi-file-edit",
      "My Tasks": "mdi-format-list-checks",
      "My Reports": "mdi-file-table",
      "Scheduled Processes": "mdi-camera-timer",
      "Process": "mdi-sitemap",
      "Form": "mdi-file-document",
      "Scheduled Reports": "mdi-av-timer",
      "Report": "mdi-file-table",
      "User": "mdi-account",
      "Group": "mdi-account-multiple",
      "Categories": "mdi-file-tree",
      "New Category": "mdi-file-tree",
      "Dashboard": "mdi-view-dashboard",
      "Password Settings": "mdi-key-variant",
      "System Configuration": "mdi-tune",
      "Database Sources": "mdi-database",
      "AI Sources": "mdi-memory",
      "Email Monitor": "mdi-email-sync",
      "Holiday": "mdi-calendar-month",
      "Business Hours": "mdi-calendar-clock",
      "System Messages": "mdi-message-text",
      "System Labels":  "mdi-translate"
    }

    
    this.recentlyVisited = this.mapIcons('recently-visited');
    this.mostRecentlyVisited = this.recentlyVisited[0];
    this.getBookmarks = () => {
     return this.mapIcons('bookmarks')
    }
    this.setCurrentState = async (label) => {
      if (!label) label = '';

      const currentState = {label, href: window.location.href};
      localStorage.setItem('currentState', JSON.stringify(currentState));
    }

    // set currentState
    this.beforeEnter = (to, from, next) => {

      // if no name provided
      if (!to.name) {
        next();
        return;
      }

      // get label for currentState from route.name
      let nameArr = to.name.split(/[\s-_]+/);
      nameArr = nameArr.map(word => word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase());

      const label = nameArr.join(' ');
      this.setCurrentState(label).catch(e => console.error(e));
      next();
    }

    // Pass in the top of the recent history to prevent re-adding current page to histroy; don't pass anything for creating bookmarks
    this.createBookmark = async (mostRecentlyVisited) => {
      let label = await waitForElement(mostRecentlyVisited);
      const href = window.location.href;
      let displayLabel = label;
      let icon = '';
      // if no label
      if (!label) {
        console.error('Cannot get bookmark label');
        return null;
      }
      let iconKey = Object.keys(this.iconMap).find((l) =>{
        return label.includes(l);
      });
      icon = this.iconMap[iconKey] || "mdi-bookmark";
      switch (true) {
        case label.startsWith('Start Request'):
          displayLabel = label;
          break;
        case label.startsWith('My Requests'):
          displayLabel = label;
          break;
        case label.startsWith('Request '):
          displayLabel = label.slice('Request '.length);
          break;
        case label.startsWith('Process - '):
          displayLabel = label.slice('Process - '.length);
          break;
        case label.startsWith('Form - '):
          displayLabel = label.slice('Form - '.length);
          break;
        case label.startsWith('Report - '):
          displayLabel = label.slice('Report - '.length);
          break;
        case label.startsWith('My Reports - '):
          displayLabel = label.slice('My Reports - '.length);
          break;
        case label.startsWith('Group Detail - '):
          displayLabel = label.slice('Group Detail - '.length);
          break;
       
      }

      return {label, displayLabel, icon, href};
    }
    
    this.addRecentlyVisited = async () => {
      const visited = await this.createBookmark(this.mostRecentlyVisited);
      if (!visited) return;
      this.mostRecentlyVisited = visited;

      // ignore links from left and top navs
      const toIgnore = pathsToIgnore.some(path => visited.href.endsWith(path) || visited.href.endsWith(`${path}/`));
      if (toIgnore) return;

      // if already in "recently visited" -> delete
      const visitedIdx = this.recentlyVisited.findIndex(v => v.href === visited.href);
      if (visitedIdx > -1) {
        this.recentlyVisited.splice(visitedIdx, 1);
      }
      // add to the beginning of array
      this.recentlyVisited.unshift(visited);
      if (this.recentlyVisited.length > MAX_RECENTLY_VISITED) {
        this.recentlyVisited.pop();
      }
      localStorage.setItem('recently-visited', JSON.stringify(this.recentlyVisited));
      }

      const pathsToIgnore = [
          'dashboards/view/tabs',

          'actions/startrequest',
          'requests/mine',
          'requests/monitor',
          'requests/manage',
          'tasks/mine',
          'request-records/mine',
          'actions/myreports_list',
          'admin/processes',
          'admin/forms',
          'admin/reports',
          'admin/users',
          'admin/groups',
          'admin/categories',
          'schedules/processes',
          'schedules/reports',

          'dashboards/admin/list',
          'system_message_list', // TODO: remove this when system messages to vue is done
          'systemsettings/systemMessages',
          'systemsettings/systemConfig',
          'systemsettings/passwordsettings',
          'systemsettings/credentialCenter',
          'systemsettings/holidays',
          'systemsettings/biztimes',
          'dbsources_list',
          'aisources',
          'translations/',
          'apikeys/',
          'sso/',
          'sessions/',
          'streams/',
          'api-index/',
          'systemInfo',
          'myaccount',
          'themeconfig',
      ];
  }

}

